import { createSlice } from "@reduxjs/toolkit";

export type BooleanReducerState = Record<string, boolean>;

const initialState: BooleanReducerState = {};

export const booleanSlice = createSlice({
  name: "booleanReducers",
  initialState,
  reducers: {
    set: (state, action) => {
      const name = String(action.payload?.name) || "";
      state[name] = action.payload.boolean;
    },
    reset: (state, action) => {
      const name = String(action.payload?.name) || "";
      state[name] = false;
    },
  },
});
